const c = {
  none: 0,
  xxxsmall: 1,
  xxsmall: 2,
  xsmall: 3,
  small: 4,
  medium: 6,
  large: 8,
  12: 12,
  xlarge: 16,
  20: 20,
  24: 24,
  xxlarge: 32,
  xxxlarge: 48
}, i = Object.keys(c), x = "small";
function s(r) {
  if (!i.includes(r))
    throw new Error(`Invalid dimension '${r}' received.

Should be one of:
	 * ${i.join(`
	 * `)}`);
}
function u(r) {
  return r.includes("%");
}
function o(r) {
  if (!r)
    return;
  if (r === "auto" || u(r))
    return r;
  const e = r.startsWith("-"), t = e ? r.slice(1) : r;
  s(t);
  const n = c[t];
  return e ? -1 * n : n;
}
function a(r) {
  return r && (typeof r == "string" ? `-${r}` : r.map(
    (e) => `-${e}`
  ));
}
function f(r) {
  const e = o(r);
  if (e !== void 0)
    return typeof e == "string" ? e : isNaN(e) ? void 0 : `${e}px`;
}
function g(r) {
  if (r)
    return r === "auto" ? r : typeof r == "string" || typeof r == "number" ? f(r) : r.map(f);
}
function v(r) {
  return `${r / 16}rem`;
}
export {
  x as DEFAULT_DIMENSION,
  c as DIMENSIONS,
  i as dimensionsArray,
  o as getDimension,
  f as getDimensionPx,
  a as makeDimensionNegative,
  g as mapResponsiveDimensionsToPx,
  v as pxToRem,
  s as validateDimension
};
